import React from 'react';

import css from './Watermark.module.scss';

const Logo: React.FC = () =>
{
  return (
        <div className={css.logo}>
          <span className={css.copy}>&copy;</span> wirtschaft.at
        </div>
  );
};

export default Logo;
